/**
 * CautionNotes — Displays caution/warning notes (if any).
 *
 * Shows important caveats or considerations for the remediation.
 */

interface CautionNotesProps {
  notes: string[];
  className?: string;
}

export function CautionNotes({ notes, className = "" }: CautionNotesProps) {
  if (notes.length === 0) {
    return null;
  }

  return (
    <section className={`remediation-cautions ${className}`}>
      <h5 className="caution-title">⚠ Caution Notes</h5>
      <ul className="caution-list">
        {notes.map((note, idx) => (
          <li key={idx}>{note}</li>
        ))}
      </ul>
    </section>
  );
}
